import { render, staticRenderFns } from "./ContractManagementModal.vue?vue&type=template&id=21f25c97"
import script from "./ContractManagementModal.vue?vue&type=script&lang=js"
export * from "./ContractManagementModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports